import React from 'react';
var selfStyles = require('./ButtonToggleAside.scss');
var ButtonToggleAside = function (props) { return (React.createElement("button", { className: selfStyles.toggleAside, onClick: props.toggleAside },
    React.createElement("svg", { id: 'menu', width: '100%', height: '100%' },
        React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 32 32' },
            React.createElement("path", { d: 'M30.4 17.6H1.6C.717 17.6 0 16.885 0 16s.717-1.6 1.6-1.6h28.8c.883 0 1.6.715 1.6 1.6s-.717 1.6-1.6 1.6zm0-11.2H1.6C.717 6.4 0 5.685 0 4.8s.717-1.6 1.6-1.6h28.8c.883 0 1.6.715 1.6 1.6s-.717 1.6-1.6 1.6zm0 22.4H1.6c-.883 0-1.6-.715-1.6-1.6s.717-1.6 1.6-1.6h28.8c.883 0 1.6.715 1.6 1.6s-.717 1.6-1.6 1.6z' }))))); };
export default ButtonToggleAside;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/ButtonToggleAside.tsx
// module id = 799
// module chunks = 0